
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { isAuthenticated, isSuperAdmin, logoutUser, getCurrentUser } from '@/utils/auth';
import { safeUserRole } from '@/utils/roleUtils';
import { SaasInstance } from '@/types/userRole';
import SuperAdminLayout from '@/components/superadmin/SuperAdminLayout';
import InstanceHeader from '@/components/superadmin/InstanceHeader';
import InstanceTabs from '@/components/superadmin/InstanceTabs';

const SuperAdminInstance = () => {
  const { id: instanceId } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [instance, setInstance] = useState<SaasInstance | null>(null);
  const [activeTab, setActiveTab] = useState('overview');
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    const checkAuth = async () => {
      const currentUser = getCurrentUser();
      const userRole = currentUser?.role || '';
      
      if (!isAuthenticated() || !isSuperAdmin(safeUserRole(userRole))) {
        navigate('/login');
        return;
      }
      
      const mockInstance: SaasInstance = {
        id: instanceId || 'unknown',
        name: 'Test Instance',
        domain: 'test.example.com',
        subdomain: 'test',
        status: 'active',
        plan: 'premium',
        ownerId: 'owner-1',
        createdAt: new Date().toISOString(), // Convert Date to string
        customization: {
          primaryColor: '#4A80F0',
          logo: '/logo.png'
        },
        settings: {
          logoUrl: '/logo.png',
          primaryColor: '#4A80F0'
        }
      };
      
      setInstance(mockInstance);
      setIsLoading(false);
    };
    
    checkAuth();
  }, [instanceId, navigate]);

  const handleLogout = async () => {
    try {
      await logoutUser();
      navigate('/login');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  if (isLoading || !instance) {
    return (
      <SuperAdminLayout isLoading={true} onLogout={handleLogout} userRole="superadmin" activeTab="instances">
        <div className="flex items-center justify-center h-64">
          <p className="text-xl font-medium">Loading...</p>
        </div>
      </SuperAdminLayout>
    );
  }

  return (
    <SuperAdminLayout isLoading={false} onLogout={handleLogout} userRole="superadmin" activeTab="instances">
      <div className="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">
        <InstanceHeader instance={instance} id={instanceId || ''} user={user} />
        <InstanceTabs 
          activeTab={activeTab} 
          setActiveTab={setActiveTab} 
          instance={instance}
          instanceId={instanceId || ''}
        />
      </div>
    </SuperAdminLayout>
  );
};

export default SuperAdminInstance;
